import styled from 'styled-components/macro'
import { Col, FormControl } from 'react-bootstrap'

export const TotalValueLockedH4 = styled.h4`
  margin-top: 1rem;
  text-align: center;
  font-weight: 600;
  color: #727eaa;

  span {
    color: #154ba0;
  }
`
export const StakeCol = styled(Col)`
  margin-bottom: 30px;
`
export const StakeWrapper = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
  padding: 30px 20px 20px;
  height: 100%;
  text-align: center;
  color: #fff;
`
export const StakeWrapperFlex = styled(StakeWrapper)`
  display: flex;
  align-items: center;
  flex: 1 1 0%;
  flex-direction: column;
  justify-content: space-between;

  h5 {
    color: #154ba0;
  }
`
export const Icon = styled.img`
  width: 40px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`
export const Icons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 0.5rem;
  background: #154ba0;
  margin: 0 auto;
`
export const LpIcons = styled(Icons)`
  img:first-child {
    width: 30px;
    margin-left: 0;
    margin-right: -20px;
    margin-top: -25px;
  }
`
export const StakeNumber = styled.h2`
  margin-top: 1rem;
  font-size: 35px;
  font-weight: 600;
  color: #154ba0;
`
export const StakeDescription = styled.p`
  margin-bottom: 0;
  font-weight: 400;
  font-size: 14px;
  color: #727eaa;
`
export const StakeButtons = styled.div`
  margin-top: 3rem;
  width: 100%;

  button {
    width: 100%;
  }
`
export const ButtonFlex = styled.div`
  margin-top: 1.5rem;
  display: flex;
  width: 100%;
  justify-content: space-between;

  button:first-child {
    width: calc(100% - 55px);
  }

  button:last-child {
    width: 45px;
  }
`
export const ShareOfPool = styled.p`
  margin-top: 1.5rem;
  font-size: 13px;
  color: #727eaa;
`
// Stake Modal
export const BalanceText = styled.p`
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  color: #154ba0;
`
export const Input = styled(FormControl)`
  box-shadow: none !important;
  border-radius: 0.5rem;
  border: 2px solid #dadfee;
  background-color: transparent !important;
  color: #727eaa !important;

  &:focus,
  &:active {
    border-color: #154ba0;
  }

  &:placeholder-shown + p {
    display: none;
  }
`

/* Locked Rewards */
export const WithdrawHeading = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dadfee;
  color: #727eaa;
  width: 100%;
  font-weight: 600;
`
export const WithdrawDiv = styled.div`
  max-height: 180px;
  width: 100%;
  overflow: auto;
`
export const StyledWithdrawRow = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
  border-bottom: 1px solid #dadfee;
  color: #727eaa;

  span {
    font-family: Oxanium, sans-serif;
  }
`
export const WithdrawAmount = styled.span`
  text-align: left;
  display: block;
  width: 60%;
`
export const WithdrawAction = styled.span`
  text-align: left;
  display: block;
  width: 40%;
  color: #727eaa;
`
export const WithdrawCountdown = styled.span`
  color: #727eaa;
`
export const WithdrawSpan = styled.span`
  cursor: pointer;
  color: #727eaa;
`
